export type TransportOrderDetailMilestoneItemProps = {
    title: string;
    detail: string;
    badgeColor: string;
    iconName: string;
};

const TransportOrderDetailMilestoneItem = ({
    title,
    detail,
    badgeColor,
    iconName,
}: TransportOrderDetailMilestoneItemProps) => (
    <div className='timeline-element margin-bottom-0'>
        <div className='timeline-date timeline-date-thin margin-right-10'>
            <span className={`badge ${badgeColor} padding-5 scale-80 `}>
                <span className={`rioglyph ${iconName}`} aria-hidden='true' />
            </span>
        </div>
        <div className='timeline-content margin-bottom-20'>
            <div className='text-size-16 text-color-darkest'>{title}</div>
            <div className='text-size-14 text-color-dark'>{detail}</div>
        </div>
    </div>
);

export default TransportOrderDetailMilestoneItem;
